import {
    StartVisitModalPayload,
    StartVisitModalWarningPayload,
} from "@/pages/WorkPlan/Tasks/StartVisit";

import { TaskProgressModalPayload } from "./TaskProgressModal";

export enum PointTasksModalType {
    StartVisit = "startVisit",
    StartVisitWarning = "startVisitWarning",
    TaskProgress = "taskProgress",
}

export type PointTasksModalState =
    | {
          type: PointTasksModalType.StartVisit;
          payload: StartVisitModalPayload;
      }
    | {
          type: PointTasksModalType.StartVisitWarning;
          payload: StartVisitModalWarningPayload;
      }
    | {
          type: PointTasksModalType.TaskProgress;
          payload: TaskProgressModalPayload;
      }
    | null;
